import React, { useMemo } from "react";
import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { Card } from "@rentablo/components";
import { CardLabel } from "@rentablo/components";
import { SparklineChart } from "../highcharts";

const Label = styled(CardLabel, {
  shouldForwardProp: (prop) => prop !== "percentPrefix",
})(({ theme }) => ({
  padding: theme.spacing(2, 4, 6),
}));

const Container = styled(Card)<{ height?: string; isFullWidth?: boolean }>(
  ({ height, isFullWidth }) => ({
    display: "flex",
    flexDirection: "column",
    padding: 0,
    boxShadow: "none",
    height: height ?? "192px",
    overflow: "hidden",
    boxSizing: "border-box",
    position: "relative",
    width: isFullWidth ? "100%" : "auto",
  })
);

export interface MiniChartProps {
  data: { date: string | Date | number; value: number }[];
  testid?: string;
  height?: string;
  onClick?: () => void;
  title: string;
  subtitle?: string;
  headline: string;
  percent?: number;
  percentPrefix?: string;
  isFullWidth?: boolean;
}

export const MiniChart = ({
  data,
  testid = "mini-card-chart",
  onClick,
  height,
  isFullWidth = false,
  ...rest
}: MiniChartProps) => {
  const chartData = useMemo(() => data.map((d) => d.value), [data]);

  return (
    <Container onClick={onClick} height={height} isFullWidth={isFullWidth}>
      <Label {...rest} />
      <Box
        data-testid={testid}
        sx={{
          width: "100%",
          position: "absolute",
          bottom: 0,
          left: 0,
          height: "67px",
          cursor: onClick ? "pointer" : "default",
        }}
      >
        <SparklineChart data={chartData} showNoDataMessage={false} />
      </Box>
    </Container>
  );
};
